import { buildModule, createFiltersModule, defineSingleFilter } from '../utils';

import detail from './detail';
import lazy from './lazy';
import list from './list';

export default buildModule()
	.withSubmodules({
		filters: createFiltersModule({
			filters: {
				searchTerm: defineSingleFilter('tagSearchTerm', String),
			},
		}),
		detail,
		lazy,
		list,
	});
